module.exports = __webpack_public_path__ + "static/cancer-0e9ee4e4822c7fe513cafed6cfc8c530.png";